import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { observer } from 'mobx-react';
import { ReactComponent as EnrichmentIcon } from 'Assets/svg/enrichment.svg';
import { ReactComponent as CSVEnrichmentIcon } from 'Assets/svg/csv-icon.svg';
import { ReactComponent as HubspotEnrichmentIcon } from 'Assets/svg/hubspot-enrichment.svg';
import { Utils } from 'Utils/utils';
import './styles.scss';
import { MX_ENRICHMENT_EVENTS } from 'Utils/constants';

const EnrichmentLanding = observer(() => {
  useEffect(() => {
    Utils.mixpanelTrack(MX_ENRICHMENT_EVENTS.ENRICHMENT_LANDING_VIEWED);
  }, []);

  return (
    <div className="enrichment-landing">
      <EnrichmentIcon className="enrichment-icon" />
      <h1 className="title">
        <span>Get Started With Enrichment </span>
        <span className="emoji">&#128075;</span>
      </h1>
      <h2 className="description">
        We&#39;ve got you covered! Select the option to enrich your records with
        Adapt&#39;s accurate data.
      </h2>
      <div className="card-wrapper">
        <Link
          to="/enrichment/file"
          onClick={() => {
            Utils.mixpanelTrack(MX_ENRICHMENT_EVENTS.ENRICHMENT_CARD_CLICKED, {
              type: 'File',
            });
          }}
        >
          <div className="enrichment-card">
            <div className="icon-wrapper">
              <CSVEnrichmentIcon className="csv-enrichment-icon" />
            </div>
            <div className="title">CSV Enrichment</div>
            <div className="description">
              Upload your CSV file and get it enriched with the data from Adapt.
            </div>
          </div>
        </Link>
        <Link
          to="/enrichment/hubspot/enrichment-log/contacts"
          onClick={() => {
            Utils.mixpanelTrack(MX_ENRICHMENT_EVENTS.ENRICHMENT_CARD_CLICKED, {
              type: 'Hubspot',
            });
          }}
        >
          <div className="enrichment-card">
            <div className="icon-wrapper">
              <HubspotEnrichmentIcon className="hubspot-enrichment-icon" />
            </div>
            <div className="title">Hubspot Enrichment</div>
            <div className="description">
              Enrich your Hubspot contacts with the data from Adapt
            </div>
          </div>
        </Link>
      </div>
    </div>
  );
});

export default EnrichmentLanding;
